"use client";

import { Layout } from "antd";
import { useState, useEffect } from "react";

import SideBarAssistant from "../SideBarAssistant/SideBarAssistant";
import NavbarAssistant from "../Navbar/NavbarAssistant";

import "./LayoutDoctor.css";

const { Sider, Content } = Layout;
const SIDER_W = 240;
const SIDER_W_COLLAPSED = 80;
const MOBILE_BREAKPOINT = 768;

export default function AppLayoutAssistant({ children }) {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth <= MOBILE_BREAKPOINT;
      setIsMobile(mobile);
      if (!mobile && mobileMenuOpen) setMobileMenuOpen(false);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, [mobileMenuOpen]);

  return (
    <Layout className="app-layout ltr">
      <Layout className="app-body">
        {isMobile && mobileMenuOpen && (
          <div
            className="mobile-sidebar-backdrop"
            onClick={() => setMobileMenuOpen(false)}
            aria-hidden="true"
          />
        )}

        <Sider
          className={`app-sider ${collapsed ? "ant-layout-sider-collapsed" : ""} ${
            isMobile ? (mobileMenuOpen ? "mobile-open" : "mobile-closed") : ""
          }`}
          width={SIDER_W}
          collapsedWidth={SIDER_W_COLLAPSED}
          collapsed={isMobile ? false : collapsed}
          trigger={null}
        >
          <SideBarAssistant
            collapsed={isMobile ? false : collapsed}
            onMenuClick={isMobile ? () => setMobileMenuOpen(false) : undefined}
          />
        </Sider>

        <Layout className={`app-main-content ${isMobile ? "is-mobile" : ""}`}>
          <div className="navbar-container">
            <NavbarAssistant
              isMobile={isMobile}
              onMobileMenuToggle={() => setMobileMenuOpen((prev) => !prev)}
            />
          </div>
          <Content className="app-layout__content">{children}</Content>
        </Layout>
      </Layout>

    </Layout>
  );
}
